/**
 * Entry point for Super-Admin impersonation links:
 * /impersonate#token=... or /impersonate?token=...
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  clearImpersonationSession,
  setImpersonationToken,
} from "../impersonationSession";

function readTokenFromLocation() {
  const hash = window.location.hash || "";
  if (hash.startsWith("#")) {
    const params = new URLSearchParams(hash.slice(1));
    const fromHash = params.get("token");
    if (fromHash) return fromHash;
  }
  const q = new URLSearchParams(window.location.search);
  return q.get("token") || "";
}

export default function ImpersonateBootstrap() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Opening customer portal…";
    try {
      const token = readTokenFromLocation();
      if (!token) {
        setError("Missing impersonation token.");
        return;
      }
      setImpersonationToken(token);
      // Drop token from URL so it is not left in history.
      window.history.replaceState(null, "", "/impersonate");
      navigate("/", { replace: true });
    } catch (e) {
      clearImpersonationSession();
      setError(e.message || "Could not start impersonation session.");
    }
  }, [navigate]);

  if (error) {
    return (
      <div style={{ padding: 40, maxWidth: 520, margin: "40px auto" }}>
        <h2 style={{ color: "#991b1b", marginTop: 0 }}>Impersonation failed</h2>
        <p style={{ color: "#374151" }}>{error}</p>
        <p style={{ color: "#6b7280", fontSize: 14 }}>
          Return to the admin portal and choose Open customer portal again.
        </p>
      </div>
    );
  }

  return (
    <div style={{ padding: 40, textAlign: "center", color: "#6b7280" }}>
      Starting impersonation session…
    </div>
  );
}
